<template>
  <modal
    name="undelete-service"
    height="auto"
    :scrollable="true"
    width="80%"
    @closed="onClose"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h2>Undelete Service</h2>
      </div>
      <div class="modal-body">
        <p class="center-align light">
          Deleted a Service by mistake? Use the checkboxes below to bring them
          back.
        </p>
        <v-card class="mb-2 pa-3" v-if="actionInProgress">
          {{ actionInProgress }}
          <v-progress-linear indeterminate />
        </v-card>
        <v-form
          class="undeletable-list"
          @submit.prevent="undeleteServices"
          v-else
        >
          <div class="grey lighten-5 row pa-0 mb-0">
            <v-list
              v-if="undeletableServices.length > 0"
              class="grey lighten-5 pt-3"
            >
              <v-list-tile
                class="pt-2"
                v-for="undeletable in undeletableServices"
                :key="undeletable.id"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-checkbox
                      hide-details
                      v-model="servicesToUndelete"
                      color="primary"
                      :value="undeletable"
                    >
                      <div slot="label">
                        <div>
                          {{ undeletable.attributes.name }}
                        </div>
                      </div>
                    </v-checkbox>
                  </v-list-tile-title>
                  <v-list-tile-sub-title class="ml-1 pl-4">
                    Deleted
                    {{ undeletable.attributes.deleted_at | moment('from') }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <div v-else class="pa-3"> No deleted Services found. </div>
          </div>
        </v-form>
        <div
          v-if="undeletableServices.length > 0"
          class="grey lighten-5 right-align row px-3 mb-0"
        >
          <v-btn
            color="primary"
            @click="undeleteServices"
            :disabled="undeleteDisabled"
          >
            Undelete Services
          </v-btn>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  computed: {
    ...mapState('services', ['undeletableServices']),
    undeleteDisabled() {
      return this.servicesToUndelete.length < 1 || !!this.actionInProgress
    },
  },
  data() {
    return {
      actionInProgress: null,
      servicesToUndelete: [],
    }
  },
  methods: {
    ...mapMutations('services', ['setUndeleteModal']),
    undeleteServices() {
      let undelete = this.servicesToUndelete.pop()
      this.actionInProgress = 'Undeleting...'

      axios.put(`/api/v1/services/${undelete.id}/undelete`).then((response) => {
        if (this.servicesToUndelete.length > 0) {
          this.undeleteServices() // Recurse until the list is exhausted
        } else {
          this.$store.dispatch('services/reloadServices')
          this.onClose()
        }
      })
    },
    onClose() {
      this.setUndeleteModal(false)
    },
  },
  mounted() {
    this.$modal.show('undelete-service')
  },
  beforeDestroy() {
    this.$modal.hide('undelete-service')
  },
}
</script>

<style scoped>
.undeletable-list {
  max-height: 25rem;
  overflow-y: auto;
}
</style>

<style>
#services-page .v--modal-overlay {
  z-index: 1005;
}

#services-page .undeletable-list .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
</style>
